import { combineReducers } from '@reduxjs/toolkit';

import clientSupportPlanRevisions from './clientSupportPlanRevisions';
import clientSupportPlans from './clientSupportPlans';

export const clients = {
  clientSupportPlans,
  clientSupportPlanRevisions,
};

export default combineReducers(clients);
